import { TextField } from '@ff-it/form';
import { Box, Card } from '@ff-it/ui';
import { FormInlineError } from 'components';
import type { Outlet } from 'modules/supplier/outletOrServiceCategory/types';
import type { ReactElement } from 'react';

import type { RadioTimeBands } from '../types';
import { DistributionEditor, DistributionModeField } from './Distribution';
import { optionField } from './formValues';
import { PricingEditor, PricingKindField } from './Pricing';

export function PackageMetadataFields(): ReactElement {
  return (
    <div className="container px-0 ml-0">
      <Box mb="3">
        <TextField name="name" label="Name" />
        <TextField
          name="terms"
          label="Shared source terms"
          placeholder="Verbatim wording, kept permanently"
          multiline
          rows={5}
        />
      </Box>
    </div>
  );
}

export function PackageOptionFields({
  name = '',
  bands,
  outlets,
}: {
  name?: string;
  bands: RadioTimeBands;
  outlets: Outlet[];
}): ReactElement {
  return (
    <div className="container px-0 ml-0">
      <Card.Container mb="3">
        <Box
          display="flex"
          flexWrap="wrap"
          alignItems="flex-start"
          gap="2"
          background="gray100"
          borderTopLeftRadius="sm"
          borderTopRightRadius="sm"
          px="3"
          py="2"
        >
          <Box flexGrow={1}>
            <TextField name={optionField(name, 'name')} label="Option name" className="mb-0" />
          </Box>
          <Box width="1/5">
            <PricingKindField name={name} />
          </Box>
          <Box width="1/5">
            <DistributionModeField name={name} />
          </Box>
        </Box>
        <Box px="3" py="2">
          <FormInlineError name={name || 'name'} className="mb-1" />
          <PricingEditor name={name} bands={bands} outlets={outlets} />
          <DistributionEditor name={name} bands={bands} outlets={outlets} />
        </Box>
      </Card.Container>
    </div>
  );
}

export function PackageCreateFields({ bands, outlets }: { bands: RadioTimeBands; outlets: Outlet[] }): ReactElement {
  return (
    <>
      <PackageMetadataFields />
      <PackageOptionFields name="options[0]" bands={bands} outlets={outlets} />
    </>
  );
}
